import {getGroupById} from '../../utils/services'

const groupCache = {}

export async function waitForCachedGroup(id, tokenProvider, profileApiUrl) {
    if (!groupCache[id]) {
        groupCache[id] = await getGroupById(id, tokenProvider, profileApiUrl)
    }
    return groupCache[id]
}

export async function waitForCachedGroups(ids, tokenProvider, profileApiUrl) {
    const groups = await Promise.all(
        ids.map((id) => waitForCachedGroup(id, tokenProvider, profileApiUrl))
    )
    return groups
}

export function getCachedGroup(id, tokenProvider, profileApiUrl) {
    const group = groupCache[id]
    if (!group) {
        waitForCachedGroup(id, tokenProvider, profileApiUrl).catch((err) =>
            console.error('Error retrieving group information: ', err)
        )
    }
    return group
}
